import axios from '@/user/axios.js'

const moduleMeasure = {
  namespaced: true,
  state: {
    categories: {},
    measures: []
  },
  mutations: {
    SET_CATEGORY_LIST (state, payload) {
      state.categories = payload
    },
    SET_MEASURE_LIST (state, payload) {
      state.measures = payload
    }
  },
  actions: {
    listCategories (context) {
      return new Promise(async (resolve, reject) => {
        try {
          const res = await axios.get('/api/measure/category')
          if (res.data.success) {
            const categories = {}
            for (const category of res.data.data) {
              categories[category.id] = { name: category.name, enabled: category.enabled }
            }
            context.commit('SET_CATEGORY_LIST', categories)
          }
          resolve(res)
        } catch (err) {
          reject(err)
        }
      })
    },
    listMeasures (context, payload) {
      return new Promise(async (resolve, reject) => {
        try {
          const sellerId = context.rootState.account.activeAccount.sellerId
          const res = await axios.get(`/api/measure/${sellerId}`, {
            params: payload
          })
          if (res.data.success) {
            context.commit('SET_MEASURE_LIST', res.data.data)
          }
          resolve(res)
        } catch (err) {
          reject(err)
        }
      })
    },
    getMeasure (context, payload) {
      return new Promise(async (resolve, reject) => {
        const { id } = payload
        try {
          const sellerId = context.rootState.account.activeAccount.sellerId
          const res = await axios.get(`/api/measure/${sellerId}/${id}`, payload)
          resolve(res)
        } catch (err) {
          reject(err)
        }
      })
    },
    addMeasure (context, payload) {
      return new Promise(async (resolve, reject) => {
        try {
          const sellerId = context.rootState.account.activeAccount.sellerId
          const res = await axios.post(`/api/measure/${sellerId}`, payload)
          resolve(res)
        } catch (err) {
          reject(err)
        }
      })
    },
    updateMeasure (context, payload) {
      return new Promise(async (resolve, reject) => {
        const { id, ...data } = payload
        try {
          const sellerId = context.rootState.account.activeAccount.sellerId
          const res = await axios.put(`/api/measure/${sellerId}/${id}`, data)
          resolve(res)
        } catch (err) {
          reject(err)
        }
      })
    },
    deleteMeasure (context, payload) {
      return new Promise(async (resolve, reject) => {
        const { id } = payload
        try {
          const sellerId = context.rootState.account.activeAccount.sellerId
          const res = await axios.delete(`/api/measure/${sellerId}/${id}`)
          resolve(res)
        } catch (err) {
          reject(err)
        }
      })
    },
    destroyMeasure (context) {
      context.commit('SET_MEASURE_LIST', [])
    }
  }
}

export default moduleMeasure
